import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\WebAuthnController::challenge
 * @see app/Http/Controllers/WebAuthnController.php:112
 * @route '/login/two-factor/webauthn/{requestType}/challenge'
 */
export const challenge = (args: { requestType: string | number } | [requestType: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: challenge.url(args, options),
    method: 'post',
})

challenge.definition = {
    methods: ["post"],
    url: '/login/two-factor/webauthn/{requestType}/challenge',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\WebAuthnController::challenge
 * @see app/Http/Controllers/WebAuthnController.php:112
 * @route '/login/two-factor/webauthn/{requestType}/challenge'
 */
challenge.url = (args: { requestType: string | number } | [requestType: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { requestType: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    requestType: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        requestType: args.requestType,
                }

    return challenge.definition.url
            .replace('{requestType}', parsedArgs.requestType.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WebAuthnController::challenge
 * @see app/Http/Controllers/WebAuthnController.php:112
 * @route '/login/two-factor/webauthn/{requestType}/challenge'
 */
challenge.post = (args: { requestType: string | number } | [requestType: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: challenge.url(args, options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\WebAuthnController::challenge
 * @see app/Http/Controllers/WebAuthnController.php:112
 * @route '/login/two-factor/webauthn/{requestType}/challenge'
 */
    const challengeForm = (args: { requestType: string | number } | [requestType: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: challenge.url(args, options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\WebAuthnController::challenge
 * @see app/Http/Controllers/WebAuthnController.php:112
 * @route '/login/two-factor/webauthn/{requestType}/challenge'
 */
        challengeForm.post = (args: { requestType: string | number } | [requestType: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: challenge.url(args, options),
            method: 'post',
        })
    
    challenge.form = challengeForm
/**
* @see \App\Http\Controllers\WebAuthnController::verify
 * @see app/Http/Controllers/WebAuthnController.php:128
 * @route '/login/two-factor/webauthn/{requestType}/verify'
 */
export const verify = (args: { requestType: string | number } | [requestType: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verify.url(args, options),
    method: 'post',
})

verify.definition = {
    methods: ["post"],
    url: '/login/two-factor/webauthn/{requestType}/verify',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\WebAuthnController::verify
 * @see app/Http/Controllers/WebAuthnController.php:128
 * @route '/login/two-factor/webauthn/{requestType}/verify'
 */
verify.url = (args: { requestType: string | number } | [requestType: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { requestType: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    requestType: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        requestType: args.requestType,
                }

    return verify.definition.url
            .replace('{requestType}', parsedArgs.requestType.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WebAuthnController::verify
 * @see app/Http/Controllers/WebAuthnController.php:128
 * @route '/login/two-factor/webauthn/{requestType}/verify'
 */
verify.post = (args: { requestType: string | number } | [requestType: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verify.url(args, options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\WebAuthnController::verify
 * @see app/Http/Controllers/WebAuthnController.php:128
 * @route '/login/two-factor/webauthn/{requestType}/verify'
 */
    const verifyForm = (args: { requestType: string | number } | [requestType: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: verify.url(args, options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\WebAuthnController::verify
 * @see app/Http/Controllers/WebAuthnController.php:128
 * @route '/login/two-factor/webauthn/{requestType}/verify'
 */
        verifyForm.post = (args: { requestType: string | number } | [requestType: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: verify.url(args, options),
            method: 'post',
        })
    
    verify.form = verifyForm
const WebAuthnController = { challenge, verify }

export default WebAuthnController